export default __webpack_public_path__ + "static/media/bg-3.516ce4f0.jpg";